
/*
  Mixin used in order to better reuse table code in the future, like pagination, filters and url queries...
*/

import { sortNumber } from "@/utils/manualSort"

const getPossibleNumber = val => {
  const parsed = parseInt(val, 10)
  if (isNaN(parsed) || parsed.length || val.length !== (parsed + "").length) {
    return val || undefined
  }
  return (parsed == 0) ? parsed : (parsed || undefined)
}

const isFunction = toCheck => toCheck && {}.toString.call(toCheck) === '[object Function]'

const SIZES_STORAGE_KEY = "sizes_storage_key:";

import { format } from 'date-fns'

export default ({
                  columnTranslationMaps = {},
                  defaultColumns = [],
                  defaultColumnTooltip = {},
                  defaultColumnShowInput = {},
                  columnConfigurationId = "",
                  filterSelectOptions,
                  minimumColumnSizes,
                  allowFullSelect,
                  defaultColumnSizes,
                  disableCache,
                  layoutFilter,

                  imageTypeOptions,
                  getImageEndpoint,
                  disableSortOnColumns,

                  manualPagination,
                  disablePageChangeRefetch,
                  selectCustomization,
                  generateFake,

                  orderSource,
                  defaultSort,
                  defaultOrder,
                  params,
                  page_size = 20,
                  route,
                  disablePlaceholder,
                  disableColumnConfiguration,
                  toISOFields,
                  getParams,
                  disableAlphabeticalSort,
                  parseParamsBeforeSending,
                  routeTriggers = [],
                  isArrayQuery = [],

                  refetchHook,

                  pageReference
                }) => {
  const sort = arr => {
    if (disableAlphabeticalSort) return arr

    const sliced = arr.slice()
    sliced.sort((name1, name2) => name1.localeCompare(name2))
    return sliced
  }

  let imageUrlsMap
  if (imageTypeOptions) {
    imageUrlsMap = imageTypeOptions.reduce((map, type) => ({
      ...map,
      [type.str]: type.value,
    }), {})

    columnTranslationMaps = {
      ...columnTranslationMaps,
      ...imageUrlsMap,
    }
  }

  let imageUrls
  if (imageUrlsMap) {
    imageUrls = Object.values(imageUrlsMap)
  }


  const columnTranslationKeys = sort(Object.keys(columnTranslationMaps))
  defaultColumns = sort(defaultColumns)

  const getDefaultColumns = configurationId => {
    const savedColumnValues = JSON.parse(localStorage.getItem(configurationId))
    return (savedColumnValues && savedColumnValues.length) ? savedColumnValues.slice() : defaultColumns.slice()
  }
  const activeColumns = sort(getDefaultColumns(columnConfigurationId))


  params = {
    ...columnTranslationKeys.map(translation => columnTranslationMaps[translation]).reduce((obj, key) => ({
      ...obj,
      [key]: "",
    }), {}),
    ...isArrayQuery.reduce((obj, key) => ({
      ...obj,
      [key]: [],
    }), {}),

    ...params,
  }

  const keys = Object.keys(params)
  let timeout

  if (!orderSource) orderSource = "order"

  return {
    props: {
      loading: {
        type: Boolean,
        required: false,
      },
    },
    data () {
      return {
        ...params,

        loadingFullSelect: false,
        fullSelectPayload: null,
        endpointParams: null,
        backgroundProducts: [],

        minimumColumnSizes,
        defaultColumnSizes,

        defaultColumnTooltip,
        defaultColumnShowInput,

        imageUrls,
        page_size,
        loadedImageUrls: false,

        page: 1,
        total: 0,
        result: [],
        placeholder: [],
        loaded: false,
        hasTemplateConfiguration: activeColumns.length && columnTranslationKeys.length,

        columnTranslationKeys,
        columnTranslationMaps,
        defaultColumns,

        currentTableColumns: activeColumns,
        columnConfigurationId,

        sort: defaultSort,
        orderSource,
        [orderSource]: defaultOrder || "asc",
        customOrder: null,
      }
    },
    beforeCreated() {
      document.body.classList.remove("loaded-table")
    },
    created() {
      let sortLocalStorage = localStorage.getItem(`set_filter_sort:${pageReference}`)
      let orderLocalStorage = localStorage.getItem(`set_filter_order:${pageReference}`)
      sortLocalStorage = sortLocalStorage && sortLocalStorage.replaceAll('"', '')
      orderLocalStorage = orderLocalStorage && orderLocalStorage.replaceAll('"', '')

      if (sortLocalStorage && sortLocalStorage !== undefined && sortLocalStorage !== "undefined") {
        this.sort = sortLocalStorage
      }
      if (orderLocalStorage && orderLocalStorage !== undefined && orderLocalStorage !== "undefined") {
        this[orderSource] = orderLocalStorage
      }

      this.extractQueryParameters()

      const callback = () => {
        if (this.activeColumnsEffect && imageUrlsMap && getImageEndpoint) {
          this.loadImageUrls(this.activeColumns)
        }
      }
      this.refetch(true, callback)

      this.customOrder = this.getColumnOrder()
      this.updateTableLoadingStatus()
    },
    methods: {
      // updateFieldAction
      async updateSingleTableRowById(id, payload, message, loadingStatusForFields) {
        const fields = Object.keys(payload)
        const toggleLoading = () => {
          // if loadingStatusForFields exists, then ONLY show loading status for the fields included on its array.
          ;(loadingStatusForFields || fields).forEach(field => this.updateOneFieldLoad(id, field))
        }

        toggleLoading() // Enable loadign
        try {
          await this.axios.put(`${this.getRoute()}/${id}`, payload)
        } catch (err) {
          this.$catchError(err)
        }
        toggleLoading() // Remove loading

        this._updateFieldsOfTableRowById(id, payload)
        this.clearFetchCache()
        message && this.$success(message)
      },

      refetchTableRow(uid, fieldInfos, message) {
        const { field } = fieldInfos

        this.updateOneFieldLoad(uid, field) // Remove loading
        this._updateFieldsOfTableRowById(uid, fieldInfos)
        this.clearFetchCache()
        message && this.$success(message)

        /*this.axios.get(`${route}/${uid}`).then(() =>{
        }).catch(() => {
          this.$error('Error')
        })*/
      },

      updateOneFieldLoad(id, field) {
        this.result = this.result.map(item => (
          item.uid === id || item.sku === id || item.id === id ? this.toggleFieldLoading(item, field) : item)
        )
      },

      toggleFieldLoading(item, field) {
        if ('_loading_field' in item) {
          // Add items
          if(!(item._loading_field.includes(field))) {
            item._loading_field.push(field)
          } else {
            // Remove itens
            const index = item._loading_field.indexOf(field);
            if (index > -1) {
              item._loading_field.splice(index, 1);
            }
          }
          return item;
        }
        return { ...item, _loading_field: [ field ]}
      },

      _updateFieldsOfTableRowById(id, updatedFields) {
        const index = this.getTableRowById(id)
        if (index < 0) throw "Row does not exist"
        Object.keys(updatedFields).forEach(field => this.result[index][field] = updatedFields[field])
        this.result = [...this.result]
      },

      getTableRowById(id) {
        return this.result.findIndex(item => item.uid === id || item.sku === id || item.id === id)
      },

      updateRow(id, obj) {
        const index = this.result.findIndex(item => item.uid === id || item.sku === id || item.id === id)
        if (index > -1) {
          this.result.splice(index, 1, {...this.result[index], ...obj})
        }
      },
      async refetchRow(uid, field = "ALL", data) {
        this.updateRow(uid, {_loading_field: field})
        const updated = (await this.axios.get(`${route}/${uid}`)).data

        if (data) {
          data._loading_field = ""
        } else {
          updated._loading_field = ""
        }
        this.updateRow(uid, data || updated)

        this.clearFetchCache()
      },
      clearFetchCache() {
        requestAnimationFrame(() => {
          this.$store.dispatch("cachedGet", {
            endpoint: this.getRoute(),
            params: { params: this.getExportParams() },
            clearCacheSearch: this.getRoute(),
            fresh: true,
          })
        })
      },
      updateColumnOrder(columns) {
        let value
        if (columns) {
          this.customOrder = [...columns].filter(item => item)
          value = JSON.stringify(columns)
        } else {
          this.customOrder = null
          value = null
        }

        localStorage.setItem(this.columnOrderKey, value)
      },
      getColumnOrder() {
        try {
          const order = localStorage.getItem(this.columnOrderKey)
          return order ? JSON.parse(order).filter(item => item) : null
        } catch (err) {
          return null
        }
      },
      getColumnSizes() {
        const sizeStorageKey = SIZES_STORAGE_KEY + this.columnConfigurationId
        let sizes = localStorage.getItem(sizeStorageKey)
        if (sizes) return JSON.parse(sizes)
        return this.defaultColumnSizes
      },
      customizeSetting() {
        this.$pushModal({
          modal: "TableSetting",
          toBind: {
            id: this.columnConfigurationId,
            value: {
              columns: this.activeColumns,
              sizes: this.getColumnSizes(),
              columnOrder: this.getColumnOrder(),
              order: { sort: this.sort, type: this[orderSource] }
            },
            callback: (setting) => {
              const { columns, columnOrder, order } = setting
              this.currentTableColumns = columns
              this.updateColumnOrder(columnOrder)
              this.sort = order.sort || 'name'
              this.order = order.type || 'asc'
            },
          }
        })
      },
      customizeLayout() {
        this.$pushModal({
          modal: "CustomizeLayout",
          toBind: {
            layoutFilter,
            id: this.columnConfigurationId,

            columns: disableColumnConfiguration ? columnTranslationKeys.filter(key => !disableColumnConfiguration.includes(key)) : columnTranslationKeys,
            defaultColumns: defaultColumns,
            currentColumns: this.activeColumns,

            selectedExtraSections: this.getSelectedExtraSections && this.getSelectedExtraSections(),
            extraSections: this.expandCustomizations,
            selectCustomization:  selectCustomization && ((...args) => selectCustomization(this, ...args)),

            callback: activeValues => {
              const newOrder = this.nameAtStartColumns.slice()
              activeValues.forEach(column => {
                if (!newOrder.includes(column)) {
                  newOrder.push(column)
                }
              })
              newOrder.forEach(column => {
                if (!activeValues.includes(column)) {
                  newOrder.splice(newOrder.indexOf(column), 1)
                }
              })

              this.currentTableColumns = newOrder
              this.updateColumnOrder(this.activeColumns)
            },
          },
        })
      },
      formatDate(date) {
        try {
          return date && format(new Date(date), "dd-MM-yyyy HH:mm")
        } catch (err) {
          return date
        }
      },
      extractQueryParameters() {
        const query = this.$route.query;
        ([...keys, "page", "sort", "order"]).forEach(key => {
          const value = !isArrayQuery.includes(key)
            ? getPossibleNumber(query[key])
            : (query[key] ? JSON.parse(decodeURIComponent(query[key])) : undefined)
          if (value) {
            this[key] = value
          }
        })
      },
      getRoute() {
        return isFunction(route) ? route(this) : route
      },
      getExportParams() {
        let params = {}

        keys.forEach(key => {
          const item = this[key]
          const value = !isArrayQuery.includes(key)
            ? getPossibleNumber(item)
            : item
          if (value) params[key] = value
        })

        if (getParams) {
          params = getParams(params, this)
        }

        const sortOptions = {}
        if (this.sort) {
          sortOptions.sort = this.sort
          sortOptions.sort_type = this[orderSource]
        }

        params = {
          page_size: this.page_size,
          page: this.page,

          ...sortOptions,
          ...params,
        }
        if (toISOFields) {
          toISOFields.forEach(key => {
            if (params[key]) {
              params[key] = new Date(params[key]).toISOString()
            }
          })
        }
        if (isArrayQuery) {
          isArrayQuery.forEach(key => {
            params[key] = params[key].map(obj => {
              if (typeof obj === "string") return obj
              return obj.uid
            })
          })
        }

        params = parseParamsBeforeSending ? parseParamsBeforeSending(params, this) : params
        const nonUndefinedParams = {}

        Object.keys(params).forEach(key => {
          if (params[key] !== undefined && params[key] !== null) nonUndefinedParams[key] = params[key]
        })

        return nonUndefinedParams
      },
      refresh() {
        this.$handlePromise(this.get(undefined, true))
      },
      async get(callback, freshData, clearOtherCache) {
        this.endpointParams = this.getExportParams()

        if(pageReference) {
          localStorage.setItem(`set_filter_sort:${pageReference}`, JSON.stringify(this.endpointParams.sort))
          localStorage.setItem(`set_filter_order:${pageReference}`, JSON.stringify(this.endpointParams.sort_type))
        }

        let data
        this.loaded = false

        if (generateFake) {
          setTimeout(() => {
            this.result = generateFake()
          }, 200)

          return this.loaded = true
        }

        try {
          const payload = {
            endpoint: this.getRoute(),
            params: { params: this.endpointParams },
            fresh: freshData || disableCache,
            // Clear all cache that starts with the given endpoint, e.g: /api/products
            clearCacheSearch: clearOtherCache && this.getRoute(),
          }
          data = (await this.$store.dispatch("cachedGet", payload)).data || []
          this.fullSelectPayload = payload
          if (callback) callback()
        } catch (err) {
          console.error(err)
          this.loaded = true
          return this.$catchError(err)
        }

        if (refetchHook) refetchHook(this)

        this.result = manualPagination ? data : data.results
        if (!this.result.length) this.res()

        this.total = manualPagination ? data.length : data.total
        this.loaded = true
      },
      async fullSelectGetSkus() {
        this.loadingFullSelect = true

        const backgroundProductsPayload = { ...this.fullSelectPayload }
        backgroundProductsPayload.params.params.page_size = 10000
        delete backgroundProductsPayload.clearCacheSearch
        delete backgroundProductsPayload.fresh

        const { results } = (await this.$store.dispatch("cachedGet", backgroundProductsPayload)).data || []
        this.backgroundProducts = results

        this.loadingFullSelect = false
      },
      async res() {
        this.page = 1
      },
      freshRefetch() {
        this.refetch(true, undefined, true, true)
      },
      refetch(noTimeout, callback, fresh, clearOtherCache) {
        if (noTimeout) return this.get(callback, fresh, clearOtherCache)

        if (!this.getRoute()) return;

        if (timeout) {
          clearTimeout(timeout)
          timeout = 0
        }

        timeout = setTimeout(() => this.get(callback, fresh, clearOtherCache), 600)
      },
      getVmValue(fieldName) {
        return this[fieldName]
      },
      assignVmValue(fieldName, value) {
        this[fieldName] = value
      },
      getFilterSelectOptions(fieldName) {
        const s = filterSelectOptions
        return s && s[fieldName] && s[fieldName](this)
      },
      getActiveColumnsFromStorage(storageKey) {
        this.columnConfigurationId = storageKey
        this.currentTableColumns = sort(getDefaultColumns(storageKey))
      },

      async loadImageUrls(columns) {
        this.loadedImageUrls = false
        const fileTypes = Object.keys(imageUrlsMap)

        if (columns.some(column => fileTypes.includes(column))) {
          this.result = await Promise.all(
            this.result.map(async (row) => {
              const newItem = {...row}

              const data = (await this.axios.get(getImageEndpoint(row))).data
              if (data.results) {
                const files = data.results
                fileTypes.forEach(columnValue => {
                  const type = imageUrlsMap[columnValue]

                  const file = files.find(file => file.type === type)

                  if (file) {
                    newItem[type] = file.thumbnail_url || file.url
                  } else {
                    newItem[type] = null
                  }
                })
              }

              return newItem
            })
          )
        } else {
          this.result = this.result.map(row => {
            const newItem = {...row}

            fileTypes.forEach(type => {
              row[type] = null
            })

            return newItem
          })
        }

        this.loadedImageUrls = true
      },

      updateTableLoadingStatus() {
        // used in cypress
        try {
          if (this.isLoadingTableResult) {
            document.body.classList.remove("loaded-table")
          } else {
            document.body.classList.add("loaded-table")
          }
        } catch (err) {
          console.error("error while changing loaded-table on .table.js updateTableLoadingStatus")
        }
      },
      sortNumber(...args) {
        return sortNumber(...args)
      },
    },
    computed: {
      disabledColumnsSort() {
        return [
          ...(imageTypeOptions ? imageTypeOptions.map(img => img.value) : []),
          ...(disableSortOnColumns || []),
        ]
      },
      pageSizeActive() {
        return this.page_size
      },
      exportEndpointParams() {
        const columns = this.tableColumnVariables

        const params = {
          ...this.endpointParams,
          columns,
        }

        delete params.page
        delete params.page_size

        return Object.keys(params)
          .filter(key => (params[key] !== undefined && (!params[key] || !params[key].map || params[key].length)))
          .reduce((obj, key) => ({
            ...obj,
            [key]: params[key],
          }), {})
      },

      columnOrderKey() {
        return "table-order:" + (columnConfigurationId || this.$route.fullPath)
      },
      isLoadingTableResult() {
        return !this.loaded || this.loading || this.customLoading
      },

      max() {
        return manualPagination ? Math.ceil(((this.filteredResult ? this.filteredResult : this.result).length) / this.page_size) : Math.ceil(this.total / this.page_size)
      },

      tablePlaceholder() {
        return this.placeholder
      },
      tableResult() {
        if (manualPagination) {
          const page = this.page - 1

          return this.isLoadingTableResult
            ? this.tablePlaceholder
            : (this.filteredResult ? this.filteredResult : this.result).slice(page * this.pageSizeActive, (page + 1) * this.pageSizeActive)
        }
        if (disablePlaceholder) return this.result.map(item => ({...item, _loading_field: item._loading_field || ""}))
        return this.isLoadingTableResult ? this.tablePlaceholder : this.result.map(item => ({...item, _loading_field: item._loading_field || ""}))
      },
      skeletonClass() {
        return this.isLoadingTableResult ? 'ske' : ''
      },


      nameAtStartColumns() {
        if (this.customOrder) return this.customOrder

        let arr = [...this.activeColumns]
        const field = "Naam"

        if (arr.includes(field)) {
          arr = [
            field,
            ...arr.filter(item => item !== field),
          ]
        }

        return arr
      },
      tableColumns() {
        return this.nameAtStartColumns
      },
      tableColumnVariables() {
        return this.nameAtStartColumns.map(translation => columnTranslationMaps[translation] || (this.customTranslationMap && this.customTranslationMap(translation)))
      },

      readyActiveColumns() {
        return !this.isLoadingTableResult && this.activeColumns
      },
      activeColumns() {
        return this.currentTableColumns
      },
    },
    watch: {
      customOrder(order) {
        const active = this.activeColumns

        if (this.customOrder && order.some(column => !active.includes(column))) {
          this.customOrder = order.filter(column => active.includes(column))
        }
      },
      isLoadingTableResult() {
        this.updateTableLoadingStatus()
      },

      sort() {
        this.refetch()
      },
      order() {
        this.refetch()
      },
      readyActiveColumns(val) {
        if (val && imageUrlsMap && getImageEndpoint) {
          this.loadImageUrls(this.activeColumns)
        }
      },

      ...routeTriggers.reduce((funcs, trigger) => ({
        ...funcs,
        [trigger]: function() {
          this.refetch()
        },
      }), {}),

      ...[
        ...keys,
        "page",
        "sort",
        "order",
      ].reduce((obj, key) => ({
        ...obj,
        [key]: function(val) {
          if (key !== 'page' && this.page !== 1) this.page = 1
          if (this.removeRouterDirect) return this.refetch();

          let param
          if (isArrayQuery.includes(key)) {
            param = val.length ? encodeURIComponent(JSON.stringify(val)) : undefined
          } else {
            param = getPossibleNumber(val)
          }

          this.$router.replace({ query: {
              ...this.$route.query,
              [key]: param,
            }}).catch(() => {})

          if (disablePageChangeRefetch && key === "page") return;
          this.refetch()
        },
      }), {}),
    },
  }
}
